
<style>
    .thumb_img {
        width: 80px;
        height: 80px;
        margin-right: 5%;
        object-fit: cover;
    }
    .card-body-padding-zero {
        padding: 0px;
    }
    .nav-tabs {
        border-bottom: 0px solid;
        border-color: #c4c9d0;
    }


    /* RESET */
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    .container {
        max-width: 1800px;
        min-width: 420px;
        margin: 40px auto;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 0.9em;
        padding-right: 0px;
        padding-left: 0px;
        color: #888;
    }

    /* Style the tabs */
    .tabs {
        overflow: hidden;
        margin-bottom: -2px;
    }

    .tabs ul {
        list-style-type: none;
        margin-left: 20px;
    }

    .tabs a{
        float: left;
        cursor: pointer;
        padding: 5px 15px;
        transition: background-color 0.2s;
        border: 1px solid #ccc;
        border-right: none;
        background-color: #f1f1f1;
        border-radius: 10px 10px 0 0;
        font-weight: bold;
    }
    .tabs a:last-child {
        border-right: 1px solid #ccc;
    }

    /* Change background color of tabs on hover */
    .tabs a:hover {
        background-color: #aaa;
        color: #fff;
    }

    /* Styling for active tab */
    .tabs a.active {
        background-color: #fff;
        color: #484848;
        border-bottom: 2px solid #fff;
        cursor: default;
    }

    /* Style the tab content */
    .tabcontent {
        border: 1px solid #e1e1e1;
        border-radius: 2px;
    }
    .box-file-input label{
        display:inline-block;
        background:#23a3a7;
        color:#fff;
        line-height:35px;
        cursor:pointer;
    }

</style>
<template>
    <div>
        <div id="tabs" class="container">

            <div class="tabs col-md-12">
                <a v-on:click="change(1)" v-bind:class="[ activetab === 1 ? 'active' : '' ]">대상자정보</a>
                <a v-on:click="change(2)" v-bind:class="[ activetab === 2 ? 'active' : '' ]">청구내역</a>
                <a v-on:click="change(3)" v-bind:class="[ activetab === 3 ? 'active' : '' ]">납부내역</a>
                <a v-on:click="change(4)" v-bind:class="[ activetab === 4 ? 'active' : '' ]">건강상태</a>
                <a v-on:click="change(5)" v-bind:class="[ activetab === 5 ? 'active' : '' ]">앨범</a>
            </div>
            <div class="content col-md-8">
                <div v-if="activetab === 1" class="tabcontent">
                    <CCard style="border:0px;">
                        <CCardBody>
                            <CForm>
                                <CInput
                                        label="* 이름 "
                                        description="대상자이름"
                                        placeholder="대상자이름"
                                        horizontal
                                        v-model="custItem.name"
                                        required
                                        was-validated
                                        readOnly=true
                                />
                                <CInput
                                        label="* 주민번호"
                                        placeholder="Text"
                                        description="대상자진료번호 6자리"
                                        horizontal
                                        v-model="custItem.citizenNo"
                                        required
                                        was-validated
                                        maxlength="6"
                                        readOnly=true
                                />
                                <CInput
                                        label="* 진료번호"
                                        placeholder="Text"
                                        description="대상자진료번호"
                                        horizontal
                                        v-model="custItem.registNo"
                                        required
                                        was-validated
                                        readOnly=true
                                />
                                <div role="group" class="test form-group was-validated form-row">
                                    <label for="uid-bbrxgh2xh9t" class="col-form-label col-sm-3"> 입원일 </label>
                                    <div class="col-sm-9">
                                        <input id="uid-bbrxgh2xh9t" type="date" required="required" class="form-control" v-model="preInDate" min="2000-01-02" max="2999-12-31" >
                                        <small class="form-text text-muted w-100">대상자입원일</small>
                                    </div>
                                </div>
                                <div role="group" class="form-group was-validated form-row">
                                    <label for="uid-dq9zl88hwf8" class="col-form-label col-sm-3"> 퇴원일 </label>
                                    <div class="col-sm-9">
                                        <input id="uid-dq9zl88hwf8" type="date" required="required" class="form-control" v-model="preOutDate" min="2000-01-02" max="2999-12-31" >
                                        <small class="form-text text-muted w-100">대상자퇴원일</small>
                                    </div>
                                </div>
                                <div role="group" class="form-group  form-row">
                                    <label for="uid-utosbj1koo" class="col-form-label col-sm-3"> 상태 </label>
                                    <div class="col-sm-9">
                                        <select id="uid-utosbj1koo"  v-model="selected" required="required"  class="form-control select" style="border-color: #e55353">
                                            <option value="I">입원</option>
                                            <option value="O">퇴원</option>
                                        </select>
                                        <small class="form-text text-muted w-100">입원/퇴원</small>
                                    </div>
                                </div>
                                <div role="group" class="form-group was-validated form-row">
                                    <label for="uid-dq9zl88hwf8" class="col-form-label col-sm-3"> 메모 </label>
                                    <div class="col-sm-9">
                                        <textarea style=" line-height: 3;" class="form-control"  v-model="memo"></textarea>
                                        <small class="form-text text-muted w-100">메모</small>
                                    </div>
                                </div>
                                <CInput
                                        label="등록일"
                                        placeholder="정보등록일"
                                        description="정보 등록일"
                                        horizontal
                                        v-model="preInsertDate"
                                        Disabled

                                />
                                <div role="group" class="form-group form-row">
                                    <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 미납액
                                        <div style="width: 100px;margin-top:40px;">
                                            <router-link :to="{name: 'paymanageunpaid', params: {custId: custItem.id}}" tag="button" class="btn btn-primary btn-sm"  color="primary">
                                                미납액 차감
                                            </router-link>
                                        </div>
                                    </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <input class="form-control" id="uid-rw1ppxoxk3h" type="text" disabled="" name="input3-group1" v-model="custItem.charge" placeholder="0">
                                            <div class="input-group-append"><span class="input-group-text">원</span></div>
                                        </div>
                                        <small class="form-text text-muted w-100">예) 6월 정기분</small>
                                    </div>
                                </div>
                            </CForm>
                        </CCardBody>
                        <CCardFooter>
                            <CButton type="button" size="sm" color="primary"   @click="submit"><CIcon name="cil-check-circle"/> 저장</CButton>
                            <CButton type="button" size="sm" color="primary" style="margin-left: 10px;"   @click="back"><CIcon name="cil-check-circle"/> 닫기</CButton>
                            <CButton label=""
                                     type="button"
                                     style="text-align: right; margin-left: 10px"
                                     class="btn btn-info " @click="deleteUser"> 대상자 삭제
                            </CButton>
                        </CCardFooter>
                    </CCard>
                </div>
                <div v-if="activetab === 2" class="tabcontent">
                    <CCard style="border:0px;">
                        <CCardBody style="border-collapse: collapse; eight: 550px; overflow: auto;">
                            <CRow>
                                <table class="table table-striped" style="border-collapse: collapse; overflow: auto;">
                                    <thead style="text-align: left;">
                                    <th width="40%">청구일</th>
                                    <th width="30%">항목</th>
                                    <th width="30%" style="text-align: right;">금액</th>
                                    </thead>
                                    <tbody class="position-relative">
                                    <tr v-for="i in this.custChargeItem">
                                        <td  @click="goChargeUpdatePage(i.id)">
                                            <div v-if="i.insertTime === null">
                                            </div>
                                            <div v-else>
                                                {{$moment(i.insertTime).format('YYYY-MM-DD')}}
                                            </div>
                                        </td>
                                        <td @click="goChargeUpdatePage(i.id)"> {{i.item}}</td>
                                        <td style="text-align: right;" @click="goChargeUpdatePage(i.id)"> {{i.amount | comma}}원</td>
                                    </tr>
                                    </tbody>
                                </table>
                                ◎ 조회된 청구내역을 수정하실려면 해당 내용을 클릭하세요
                            </CRow>
                            <CRow style="margin-top: 3%;">
                                <CCol>
                                    <div id="tje5Special" style="width: 100%;">
                                        <ul class="cf">
                                            <li>
                                                <p>합계금액 : {{chargeTotalAmount | comma}} 원</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <CButton type="button"  size="sm" color="primary" @click="$router.push({name: 'paymanagecharge'})"><CIcon name="cil-check-circle" /> 금액청구</CButton>
                                    <CButton type="button"  size="sm" color="primary" style="margin-left: 10px;" @click="$router.push({name: 'paymanagementlist'})"><CIcon name="cil-check-circle" /> 닫기</CButton>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </div>
                <div v-if="activetab === 3" class="tabcontent">
                    <CCard style="border:0px;">
                        <CCardBody style="border-collapse: collapse; height: 550px;  overflow: auto;">
                            <CRow>
                                <table class="table table-striped" style="border-collapse: collapse;  overflow: auto;">
                                    <thead style="text-align: left;">
                                    <th width="18%">납부일</th>
                                    <th width="18%">납부구분</th>
                                    <th width="18%" style="text-align: right;">카드</th>
                                    <th width="18%" style="text-align: right;">금액</th>
                                    <th width="18%" style="text-align: center;">결제상태</th>
                                    <th width="" style="text-align: right;">비고(납부자)</th>
                                    </thead>
                                    <tbody class="position-relative">
                                    <tr v-for="p in this.custPayItem">
                                        <td @click="goPayDetailUpdatePage(p.payId, p.payType)">
                                            <div v-if="p.insertTime === null">
                                            </div>
                                            <div v-else>
                                                {{$moment(p.insertTime).format('YYYY-MM-DD')}}
                                            </div>
                                        </td>
                                        <td @click="goPayDetailUpdatePage(p.payId, p.payType)">
                                            <div v-if="p.payType === '1'">
                                                <div v-if="p.payMethod === 'C'">
                                                    온라인(카드)
                                                </div>
                                                <div v-if="p.payType === 'M'">
                                                    온라인(현금)
                                                </div>
                                            </div>
                                            <div v-else-if="p.payType === '2'">
                                                <div v-if="p.payMethod === 'C'">
                                                    오프라인(카드)
                                                </div>
                                                <div v-if="p.payType === 'M'">
                                                    오프라인(현금)
                                                </div>
                                                <div v-if="p.payType === 'P'">
                                                    오프라인
                                                </div>
                                            </div>
                                            <div v-else="p.payType === '3'">
                                                할인
                                            </div>
                                        </td>
                                        <td>
                                            {{p.cardCode}}
                                        </td>
                                        <td style="text-align: right;" @click="goPayDetailUpdatePage(p.payId, p.payType)">
                                            <div v-if="p.payStatus === 'S'" style="text-align: center;">
                                                {{p.amount | comma}}원
                                            </div>
                                            <div v-if="p.payStatus != 'S'" style="text-align: center;">
                                                -{{p.amount | comma}}원
                                            </div>
                                        </td>
                                        <td @click="goPayDetailUpdatePage(p.payId, p.payType)">
                                            <div v-if="p.payStatus === 'S'" style="text-align: center;">
                                                결제성공
                                            </div>
                                            <div v-else-if="p.payStatus === 'F'" style="text-align: center;">
                                                결제실패
                                            </div>
                                            <div v-else="p.payStatus === 'C'" style="text-align: center;">
                                                결제취소
                                            </div>
                                            <div v-else="p.payStatus === 'N'" style="text-align: center;">
                                                결제대기
                                            </div>
                                        </td>
                                        <td @click="goPayDetailUpdatePage(p.payId, p.payType)" style="text-align: right;"> {{p.userInfo}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </CRow>
                            <CRow style="margin-top: 3%;">
                                <CCol>
                                    <div id="tje5Special" style="width: 100%;">
                                        <ul class="cf">
                                            <li>
                                                <p>합계금액 : {{custPayTotalAmount | comma}} 원</p>
                                            </li>
                                        </ul>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </div>
                <div v-if="activetab === 4" class="tabcontent">
                    <CNavbar light color="light" style="margin-bottom: 20px; width: 100%;">
                        <CForm inline>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-12 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="change(4)">검색</CButton>
                            <CButton label=""
                                     type="button"
                                     style="text-align: right; margin-left: 10px;"
                                     class="btn-sm btn-info" @click="insertWellness">건강상태 등록
                            </CButton>
                        </CForm>
                    </CNavbar>
                    <CCard style="border: 0px;">
                        <CCardBody style="border-collapse: collapse; height: 550px; overflow: auto;">
                            <CRow>
                                <CCol  v-for="h in this.custWellnessItem"  v-bind:data="h" v-bind:key="h.custId"  sm="6" md="6">
                                    <CCard v-if="h.insertTime === null" accent-color="info">
                                    </CCard>
                                    <CCard v-else accent-color="info" style="cursor: pointer;"  v-on:click="custWellnessUpdate(h)">
                                        <CCardHeader>
                                            {{$moment(h.checkDate).format('YYYY-MM-DD')}}
                                            <span v-if="h.item1 === 1" class="badge badge-secondary float-right" style="padding: 7px;margin-right: 5px;">식사량 적음</span>
                                            <span v-if="h.item1 === 2" class="badge badge-secondary float-right" style="padding: 7px;margin-right: 5px;">식사량 보통</span>
                                            <span v-if="h.item1 === 3" class="badge badge-secondary float-right" style="padding: 7px;margin-right: 5px;">식사량 좋음</span>
                                            <span v-if="h.item2 === 1" class="badge badge-success float-right" style="padding: 7px;margin-right: 5px;">대소변 나쁨</span>
                                            <span v-if="h.item2 === 2" class="badge badge-success float-right" style="padding: 7px;margin-right: 5px;">대소변 보통</span>
                                            <span v-if="h.item2 === 3" class="badge badge-success float-right" style="padding: 7px;margin-right: 5px;">대소변 좋음</span>
                                        </CCardHeader>
                                        <div class="card-body p-3 d-flex align-items-center">
                                            <div v-if="h.attachId == null" class="bg-gradient-warning mfe-3" >
                                                첨부파일 없음
                                                <!--<img  style="width: 150px;height: 100px;" src="../../assets/img/noimg.gif">-->
                                            </div>
                                            <div v-if="h.attachId != null" class="bg-gradient-info mfe-3" >
                                                첨부파일 있음
                                                <!--<img style="width: 150px; height: 100px;" :src="'/hospital/fileAttachLoad?attachId=' + h.attachId">-->
                                            </div>
                                            <div>
                                                <!--<div class="text-value text-warning"></div>-->
                                                <div class="text-muted text-uppercase font-weight-bold small"> {{h.memo}}</div>
                                            </div>
                                        </div>
                                       <!-- <div class="card-footer px-3 py-2"><a class="btn-block text-muted d-flex justify-content-between align-items-center" href="#"><span class="small font-weight-bold">상세보기</span>
                                            <svg class="c-icon">
                                                <use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-chevron-right"></use>
                                            </svg></a></div>-->
                                    </CCard>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol class="btn-col-margin ml-4" sm="1">
                                    <button label=""
                                            type="button"
                                            class="btn btn-info btn-block"
                                            @click="back">닫 기
                                    </button>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </div>
                <div v-if="activetab === 5" class="tabcontent">
                    <CNavbar light color="light" style="margin-bottom: 20px; width: 100%;">
                        <CForm inline>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="change(5)">검색</CButton>
                            <CButton label=""
                                     type="button"
                                     style="text-align: right; margin-left: 10px;"
                                     class="btn-sm btn-info" @click="insertAlbum">앨범 등록
                            </CButton>
                        </CForm>
                    </CNavbar>
                    <CCard style="border:0px;">
                        <CCardBody style="border-collapse: collapse; height: 550px; overflow: auto;">
                            <CRow>
                                <CCol  v-for="p in this.albumItem"  v-bind:data="p" v-bind:key="p.albumId" sm="6" md="2" style="min-width: 155px;"><!-- -->
                                    <CCard v-if="p.insertTime === null" accent-color="info">
                                    </CCard>
                                    <CCard v-else accent-color="info" v-on:click="custAlbumUpdate(p)">
                                        <CCardHeader>
                                            {{$moment(p.picDate).format('YYYY-MM-DD')}}
                                        </CCardHeader>
                                        <CCardBody  class="card-body-padding-zero" style="margin: auto;">
                                            <div role="group" class="form-group  form-row">
                                                <div class="col-sm-4">
                                                        <img style="width: 100px;height: 100px" :src="'/silver/fileLoad?albumId=' + p.albumId">
                                                </div>
                                            </div>
                                        </CCardBody>
                                    </CCard>
                                </CCol>
                            </CRow>
                            <CCol class="btn-col-margin ml-4" sm="1">
                                <button label=""
                                        type="button"
                                        class="btn btn-info btn-block"
                                        @click="back">닫 기
                                </button>
                            </CCol>
                        </CCardBody>
                    </CCard>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'


    Vue.use(VueMoment)

    export default {
        name: 'paymanageupdate',
        components: {
        },
        data() {
            return{
                activetab: 1,
                options: ['입원', '퇴원'],
                custItem: {},
                src:'',
                custPayItem: {},
                custChargeItem: {},
                custWellnessItem: {},
                custWellnessLatestItem: {},
                albumItem: {},
                payItems: {},
                item: null,
                preInDate: '',
                preOutDate: '',
                preInsertDate: '',
                chargeDate: '',
                selected: '',
                memo: '',
                startMonthVal:  this.$moment().add(-30,'d') .format('YYYY-MM-DD'),
                endMonthVal: this.$moment().format('YYYY-MM-DD'),
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted() {
            const custId = this.$route.params.custId;
            axios.get('silver/cust/update/'+custId)
            .then(res => {
                this.custItem = res.data.cust;
           /*     this.custPayItem = res.data.custPay;
                this.custChargeItem = res.data.custCharge;
                this.albumItem = res.data.album;
                this.custWellnessLatestItem = res.data.custWellnessLatest;
                this.custWellnessItem = res.data.custWellness;*/
                this.preInDate =  this.$moment(res.data.cust.inDate).format('YYYY-MM-DD');
                this.preOutDate = this.$moment(res.data.cust.outDate).format('YYYY-MM-DD');
                this.preInsertDate = res.data.cust.insertDate.slice(0, 10);
                this.selected = res.data.cust.custStatus;
                this.memo = res.data.cust.memo;
                this.chargeTotalAmount = res.data.chargeTotalAmount;
                this.custPayTotalAmount = res.data.custPayTotalAmount;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        methods: {
            submit () {
                if(this.preOutDate == 'Invalid date'){
                    this.preOutDate = ''
                }
                axios.post('/silver/cust/custUpdate', {
                    id: this.$route.params.custId,
                    name: this.custItem.name,
                    registNo: this.custItem.registNo,
                    citizenNo: this.custItem.citizenNo,
                    custStatus: this.selected,
                    inDate:  this.preInDate,
                    outDate:this.preOutDate,
                    charge: this.custItem.charge,
                    memo: this.memo
                })
                .then(data => {
                    this.$router.push({name:"paymanagementlist"})
                })
                .catch(function (error) {
                    console.log(error)
                });
            },
            insertWellness : function(id) {
                this.$router.push({name:"paymanagewellnessinsert"})
            },
            custWellnessUpdate(item) {

                this.$router.push({name: 'paymanagewellnessup', params: {custId: item.custId, checkDate: item.checkDate}});

            },
            insertAlbum : function(id) {
                this.$router.push({name:"paymanagealbuminsert"})
            },
            goChargeUpdatePage(id) {
                this.$router.push({name: 'chargeUpdate', params: {chargeId:id}});
            },
            goPayDetailUpdatePage(id, payType) {
                if(payType === '1') {
                    this.$router.push({name: 'paydetail', params: {payId: id}});
                }
            },
            custAlbumUpdate(item) {
                this.$router.push({name:"paymanagealbumup",params: {custId: item.custId, picDate: item.picDate, albumId: item.albumId}})
            },
            deleteUser() {
                if(confirm('삭제하시겠습니까?')){
                    const custId = this.$route.params.custId;
                    axios.post('silver/cust/delete/'+custId)
                        .then(res => {
                            console.log(res.data);
                            if(res.data.deleteChk == true){
                                alert("삭제되었습니다.");
                                this.$router.push({name:"paymanagementlist"});
                            }else{
                                alert("미납액이 존재합니다.");
                            }

                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },
            change(item){

                console.log(item);
                this.activetab = item;



                var url = "";
                var custId = this.$route.params.custId;

                if(item == 1){
                    this.custItem = '';
                    this.custPayItem = '';
                    this.custChargeItem = '';
                    this.albumItem ='';
                    this.custWellnessLatestItem = '';
                    this.custWellnessItem = '';
                    url = 'silver/cust/update/';
                }
                if(item == 2){
                    this.custItem = '';
                    this.custPayItem = '';
                    this.custChargeItem = '';
                    this.albumItem ='';
                    this.custWellnessLatestItem = '';
                    this.custWellnessItem = '';
                    this.chargeTotalAmount = '';
                    url = 'silver/cust/update/custCharge/';
                }
                if(item == 3){
                    this.custItem = '';
                    this.custPayItem = '';
                    this.custChargeItem = '';
                    this.albumItem ='';
                    this.custWellnessLatestItem = '';
                    this.custWellnessItem = '';
                    this.custPayTotalAmount = '';
                    url = 'silver/cust/update/custPay/';
                }
                if(item == 4){
                    this.custItem = '';
                    this.custPayItem = '';
                    this.custChargeItem = '';
                    this.albumItem ='';
                    this.custWellnessLatestItem = '';
                    this.custWellnessItem = '';
                    url = 'silver/cust/update/custWellness/';
                }
                if(item == 5){
                    this.custItem = '';
                    this.custPayItem = '';
                    this.custChargeItem = '';
                    this.albumItem ='';
                    this.custWellnessLatestItem = '';
                    this.custWellnessItem = '';
                    this.startMonthVal
                    url = 'silver/cust/update/album/';
                }
                axios.get(url+custId+"?startMonthVal="+this.startMonthVal+"&endMonthVal="+this.endMonthVal)
                    .then(res => {
                        if(item == 1) {
                            this.custItem = res.data.cust;
                            this.preInDate =  this.$moment(res.data.cust.inDate).format('YYYY-MM-DD');
                            this.preOutDate = this.$moment(res.data.cust.outDate).format('YYYY-MM-DD');
                            this.preInsertDate = res.data.cust.insertDate.slice(0, 10);
                            this.selected = res.data.cust.custStatus;
                            this.memo = res.data.cust.memo;
                        } else if(item == 2) {
                            this.custChargeItem = res.data.custCharge;
                            this.chargeTotalAmount = res.data.chargeTotalAmount;
                        } else if(item == 3) {
                            console.log(res.data.custPay);
                            this.custPayItem = res.data.custPay;
                            this.custPayTotalAmount = res.data.custPayTotalAmount;
                        } else if(item == 4) {
                            console.log("4")
                            this.custWellnessItem = res.data.custWellness;
                        } else if(item == 5) {
                            this.albumItem = res.data.album;
                        }

                 /*       this.custPayItem = res.data.custPay;
                        this.custChargeItem = res.data.custCharge;
                        this.albumItem = res.data.album;
                        this.custWellnessLatestItem = res.data.custWellnessLatest;
                        this.custWellnessItem = res.data.custWellness;
*/


                    })
                    .catch(function(error) {
                        console.log(error);
                    });

            },


            searchAlbum(value){
                    const qs = require('querystring');
                    const formData = qs.stringify({
                        'startMonthVal': this.startMonthVal
                        ,'endMonthVal': this.endMonthVal
                    });

                    axios.post('silver/cust/album', formData)
                        .then(res => {
                            this.items = res.data;
                            this.albumItem = [];

                            // 입퇴원 상태 변환   ex) O -> 입원
                            for(var i = 0; i < this.items.length; i++){
                                const obj = new Object();

                                obj.id = this.items[i].id;
                                obj.custId = this.items[i].custId;
                                obj.transId = this.items[i].transId;
                                obj.insertTime = this.items[i].insertTime.toString().slice(0, 10);
                                obj.custName = this.items[i].custName;
                                obj.registNo = this.items[i].registNo;
                                console.log(this.items[i].payType);
                                if(this.items[i].payType == "1"){
                                    obj.payType = "온라인(카드)";
                                } else if(this.items[i].payType == "2") {
                                    obj.payType = "오프라인";
                                } else {
                                    obj.payType = "금액조정";
                                }
                                obj.amount = this.comma(this.items[i].amount)+"원";
                                obj.userInfo = this.items[i].userInfo;

                                this.newItems.push(obj);
                            }
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            back() {
                this.$router.push({name:"paymanagementlist"})
            }
        }
    }
</script>
